import { useTranslation } from 'react-i18next';
import { Flex } from '@chakra-ui/react';

import { TextBold } from 'UiKit/typography';
import { Condition } from 'Component/others';
import { reportHeadText } from 'Const/report/text';

import SyncSkeleton from 'View/report/component/syncSkeleton';

import styles from './styles.module.css';

const Head = ({ data, isFetching }) => {
  const { t } = useTranslation('report-live');

  return (
    <Flex className={styles['head__container']}>
      <TextBold className={styles['title__text']}>{t('head.title')}</TextBold>
      <Condition statement={!isFetching} fallback={<SyncSkeleton />}>
        <TextBold className={styles['last-sync__text']}>
          {reportHeadText?.syncText} :<br /> {data?.lastSync}
        </TextBold>
      </Condition>
    </Flex>
  );
};

export default Head;
